import { intl, ui } from '@beelday/common'
import { useCallback, useEffect, useState } from 'react'
import { useAssertedJoinedRoomAddress } from 'room/common/use-joined-room-address'
import useYouTubeStreamingApi from './youtube-streaming-api'
import { YouTubeStreamDefinition } from './model'
import { YouTubeStreamingList } from './youtube-stream-list'

type Props = {
	onClose: () => void
}

export const StartYouTubeStream = ({ onClose }: Props): JSX.Element => {
	const address = useAssertedJoinedRoomAddress()
	const youTubeApi = useYouTubeStreamingApi()
	const [youtubeStreams, setYoutubeStreams] = useState<
		Array<YouTubeStreamDefinition>
	>([])

	useEffect(() => {
		youTubeApi.all(address).then(setYoutubeStreams)
	}, [address, youTubeApi])

	const handleSelect = useCallback(
		(youtubeId: string) => {
			youTubeApi.current(address, youtubeId).then(onClose)
		},
		[address, onClose, youTubeApi]
	)

	const handleCreate = useCallback(
		(definition: YouTubeStreamDefinition) => {
			youTubeApi
				.create(address, definition)
				.then(() => youTubeApi.current(address, definition.id))
				.then(onClose)
		},
		[address, onClose, youTubeApi]
	)

	return (
		<ui.RightDetailsPanel
			header={
				<ui.RightDetailsPanel.SubTitleAndTitle
					title={
						<intl.Translate>
							room_menu.youtube_stream.start_title
						</intl.Translate>
					}
					subTitle={
						<intl.Translate>
							room_menu.youtube_stream.start_subtitle
						</intl.Translate>
					}
				/>
			}
			onClose={onClose}
		>
			<ui.FlexColumn style={{ rowGap: '40px', paddingBottom: '20px' }}>
				<YouTubeStreamingList
					youtubeStreams={youtubeStreams}
					onSelect={handleSelect}
					onCreate={handleCreate}
				/>
			</ui.FlexColumn>
		</ui.RightDetailsPanel>
	)
}
